export default { 
  clubes: [],
}